import { Consumer } from '../Context'
import Loader from './Loader'

export default function Login() {
  return (
    <Consumer>
      {(props) => (
        <form onSubmit={props.handleSubmit}>
          <div className="form-group">
            <input
              type="email"
              name="studentEmail"
              className="form-control"
              placeholder="Enter your NYIT Email Address"
              autoComplete="email"
              autoCapitalize="none"
              spellCheck="false"
              required
            />
          </div>
          <button type="button" id="button-link" onClick={(e) => props.setIsStudent(e, false)}>
            Not a College of Osteopathic Medicine Student?
          </button>
          <button
            disabled={props.loading}
            type="submit"
            className="d-flex btn btn-primary ml-auto button__load"
          >
            {props.loading ? <Loader /> : <span>Check In</span>}
          </button>
        </form>
      )}
    </Consumer>
  )
}
